import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import Image from '../Image';
import css from './ImageOnly.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ImageOnly = function ImageOnly(_ref) {
  var className = _ref.className,
      description = _ref.description,
      image = _ref.image,
      imageMobile = _ref.imageMobile,
      textColor = _ref.textColor;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("header", {
      className: cc([css.root, className]),
      children: [image && /*#__PURE__*/_jsx("div", {
        className: cc([css.img, css.desktop]),
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          alt: "Collection Banner",
          className: css.image,
          lazyload: false,
          sizes: [800, 1000, 1200, 1400, 1600]
        }))
      }), imageMobile && /*#__PURE__*/_jsx("div", {
        className: cc([css.img, css.mobile]),
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageMobile), {}, {
          alt: "Collection Banner",
          lazyload: false,
          className: css.image,
          sizes: [550]
        }))
      })]
    }), description && /*#__PURE__*/_jsx("div", {
      className: css.descriptionWrap,
      children: /*#__PURE__*/_jsx("div", {
        className: css.description,
        dangerouslySetInnerHTML: {
          __html: description
        },
        style: {
          color: textColor
        }
      })
    })]
  });
};

ImageOnly.defaultProps = {
  className: false,
  description: false,
  image: false,
  imageMobile: false,
  textColor: ''
};
ImageOnly.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  imageMobile: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  textColor: PropTypes.string
};
export default ImageOnly;